import { reduxForm } from 'redux-form'
import onChange from './onChange'
import submit from './submit'
import validate, { shouldAsyncValidate } from './validate'

export interface IFilterRoomsValues {
  dateFrom?: Date
  dateTo?: Date
  daysCount?: number
  numPersons?: number
  name?: string
}

export default reduxForm<IFilterRoomsValues, {}>({
  asyncChangeFields: ['dateFrom', 'daysCount', 'dateTo'],
  asyncValidate: validate(),
  destroyOnUnmount: false,
  enableReinitialize: true,
  form: 'filterRooms',
  onChange,
  onSubmit: submit,
  shouldAsyncValidate: shouldAsyncValidate,
})
